import { render, staticRenderFns } from "./batchBorder.vue?vue&type=template&id=47e0999f&scoped=true"
import script from "./batchBorder.vue?vue&type=script&lang=js"
export * from "./batchBorder.vue?vue&type=script&lang=js"
import style0 from "./batchBorder.vue?vue&type=style&index=0&id=47e0999f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0999f",
  null
  
)

export default component.exports